export default __webpack_public_path__ + "static/media/Supplier_Product_Promotion_2108_0309_2025.d2f905ed.xlsx";